import { render, staticRenderFns } from "./ChoiceMaterials.vue?vue&type=template&id=36e3ae24&scoped=true&"
import script from "./ChoiceMaterials.vue?vue&type=script&lang=js&"
export * from "./ChoiceMaterials.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceMaterials.vue?vue&type=style&index=0&id=36e3ae24&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e3ae24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VCol,VContainer,VRow})
